export default __webpack_public_path__ + "static/media/Atmaram.bd159d4e.svg";